import { AuthProvider } from '@doss/common-all'
import { appSdkAssetBaseFor } from '@doss/guest-frame/app-sdk'

// Staging Firebase Config
const firebaseConfig = {
  apiKey: 'AIzaSyDYb5fDAk6z9mLd5leYn8_uSYHgdkXXU8M',
  authDomain: 'staging-383416.firebaseapp.com',
  databaseURL: 'https://staging-383416-default-rtdb.firebaseio.com',
  projectId: 'staging-383416',
  storageBucket: 'staging-383416.appspot.com',
  messagingSenderId: '37653837791',
  appId: '1:37653837791:web:9b7b0726137515a7c0f66a',
  measurementId: 'G-N59HBHD4C2',
}

export const config = {
  adminBaseUrl: 'staging.admin.doss.com',
  apiBaseUrl: 'staging.api.doss.com',
  webBaseUrl: 'staging.app.doss.com',
  webhooksBaseUrl: 'staging.webhooks.doss.com',
  docuforgeBaseUrl: 'staging.docuforge.doss.com',
  appSdkAssetBase: appSdkAssetBaseFor('staging'),
  sentryUrl:
    'https://819f3f17d2ab4a958e31abc91fdfa8b1@o4504896410025984.ingest.sentry.io/4505035079483392',
  logrocketId: 'l3k4df/doss-web',
  protocol: 'https',
  websocketProtocol: 'wss',
  firebaseConfig,
  jitsuHost: 'https://staging.jitsu.doss.com',
  jitsuWriteKey: 'wUW2jzDKrq8XkQ4OEK1XEcec0r86tiH3:dq4b2HLJWJW7Vp7H7SwXwguRMlY6VoxU',
  analyticsJitsuEnabled: true,
  perfTelemetryEnabled: true,
  stripePublishableKey:
    'pk_test_51LoEBoIr04lJNUdf2K625ZzB9nCgCsGHbqV16AnqzvpCXT63ggox6GgwetYTBHgUeJwFXY9zuQL3TdyCNHrhr51f00W38Np6C3',
  gcpServiceAccountEmail: '37653837791-compute@developer.gserviceaccount.com',
  stripeStagingPublishableKey:
    'pk_test_51LoEBoIr04lJNUdf2K625ZzB9nCgCsGHbqV16AnqzvpCXT63ggox6GgwetYTBHgUeJwFXY9zuQL3TdyCNHrhr51f00W38Np6C3',
  // Auth provider: Defaults to 'workos', legacy is 'firebase' can be overridden with VITE_AUTH_PROVIDER in Vercel
  authProvider: (import.meta.env.VITE_AUTH_PROVIDER || 'workos') as AuthProvider,
  loopReturnsInstallUrl:
    'https://admin.loopreturns.com/third-party-integration/install/f37b436e-b665-4a40-83e8-ee975de6d821',
}
